import { configApi } from '../http-client.js'

/**
 * Fetch data subject counts for consent analytics dashboard
 * @param {Object} params - Query parameters
 * @param {string} params.fromDate - ISO date string for start date (optional)
 * @param {string} params.toDate - ISO date string for end date (optional)
 * @param {number} params.limit - Maximum number of time series records (optional)
 * @returns {Promise<Object>} Data subject counts with snapshot and time series
 */
export const getDataSubjectCounts = ({ fromDate, toDate, limit } = {}) => {
	const params = new URLSearchParams()

	if (fromDate) {
		params.append('fromDate', fromDate)
	}
	if (toDate) {
		params.append('toDate', toDate)
	}
	if (limit) {
		params.append('limit', limit)
	}

	const queryString = params.toString()
	const url = queryString
		? `api/ConsentAnalytics/DataSubjectCounts?${queryString}`
		: 'api/ConsentAnalytics/DataSubjectCounts'

	return configApi
		.get(url)
		.then(response => response.data)
}
